import { render } from "./log.vue?vue&type=template&id=101953f0"
import script from "./log.vue?vue&type=script&lang=js"
export * from "./log.vue?vue&type=script&lang=js"
script.render = render

export default script